const SESSION_SYSTEM = "SEMESTER"
const SITE_NAME = "Oylan"
const CONTENT_SOURCE = "oylan"

module.exports = {
    SESSION_SYSTEM,
    SITE_NAME,
    CONTENT_SOURCE
}
